<template>
    <ul class="main-nav align-items-lg-center">
        <li class="d-none d-lg-block" v-if="isHomeOneRoute">
            <div>
                <div class="dropdown">
                    <a href="javascript:void(0);" class="dropdown-toggle bg-light-300 fw-medium"
                        data-bs-toggle="dropdown">
                        <i class="ti ti-layout-grid me-1"></i>Categories
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="javascript:void(0);">Construction</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0);">Removals</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0);">Interior</a></li>
                    </ul>
                </div>
            </div>            
        </li>
        <template v-for="mainMenu in navItems" :key="mainMenu.tittle">
            <template v-if="mainMenu.separateRoute === false">
                <li class="has-submenu" 
                    :class="{  'megamenu' : mainMenu.tittle === 'Home', 'active' : isActiveLink(mainMenu.active_link) || isActiveLink(mainMenu.active_link1) || isActiveLink(mainMenu.active_link2) || isActiveLink(mainMenu.active_link3), }">
                    <a href="javascript:void(0);" @click="mainMenu.showAsTab = !mainMenu.showAsTab">
                        {{ mainMenu.tittle }}
                        <i class="fas fa-chevron-down"></i>
                    </a>
                    <ul class="submenu" :class="{ 'd-block': mainMenu.showAsTab === true }">
                        <template v-for="menu in mainMenu.menu" :key="menu.menuValue">
                            <template v-if="menu.hasSubRoute === false && mainMenu.tittle !== 'Home'">
                                <li :class="{ 'active' :  isActiveLink(menu.active_link) || isActiveLink(menu.active_link1)|| isActiveLink(menu.active_link2) || isActiveLink(menu.active_link3) }">
                                    <router-link :to="menu.routes">
                                        {{ menu.menuValue }} 
                                    </router-link>
                                </li>
                            </template>
                            <template v-if="menu.hasSubRoute === true">
                                <li class="has-submenu" :class="{ active: isActiveSubMenu(menu) }">
                                    <a href="javascript:void(0);">
                                        {{ menu.menuValue }}
                                    </a>
                                    <ul class="submenu"
                                        :class="{
                                            'd-block': menu.showSubRoute === true,
                                        }"
                                    >
                                        <template v-for="subMenu in menu.subMenus" :key="subMenu.menuValue">
                                            <li :class="{ active: isActiveLink(subMenu.routes) }">
                                                <router-link :to="subMenu.routes">
                                                    {{ subMenu.menuValue }}
                                                </router-link>
                                            </li>
                                        </template>
                                    </ul>
                                </li>
                            </template>
                            <template v-if="menu.menuValue === 'Home'">
                                <li>
                                    <div class="megamenu-wrapper">
                                        <div class="row">
                                            <template v-for="subItem in mainMenu.menu" :key="subItem.menuValue">
                                                <div class="col-lg-2">
                                                    <div class="single-demo" :class="{ 'active' : isActiveLink(subItem.active_link) }">
                                                        <div class="demo-img">
                                                            <router-link :to="subItem.routes">
                                                                <img :src="require(`@/assets/img/${subItem.img}`)" class="img-fluid" alt="img"/>
                                                            </router-link>
                                                        </div>
                                                        <div class="demo-info">
                                                            <router-link :to="subItem.routes">
                                                                {{ subItem.menuValue }}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </template>
                    </ul>
                </li>
            </template>
        </template>
        <template v-if="$route.path === '/home/index'">
            <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);" data-bs-toggle="modal"
                    data-bs-target="#provider">Become a Provider</a>
            </li>	
        </template>
        <li><router-link to="/admin/index" @click="redirectReload">Admin</router-link></li>
    </ul>
</template>
  
<script>
import navItems from "@/assets/json/header-menu.json";
export default {
  data() {
    return {
        route_array: [],
        navItems: navItems,
    };
  },
  computed: {
        isHomeOneRoute() {
            return  this.$route.path === "/home/index";
        },
        currentPath() {
            return this.getCurrentPath();
        },
    },
    methods: {
        redirectReload() {
            this.$router.push({ path: "/admin/index" }).then(() => {
                this.$router.go();
            });
        },
        getCurrentPath() {
            this.route_array = this.$route.path.split("");
            return this.$route.path;
        },
        isActiveLink(link) {
            return this.currentPath.includes(link);
        },     
        isActiveSubMenu(menu) {
            return menu.subMenus.some((subMenu) => this.isActiveLink(subMenu.routes));
        },
    },
};
</script>
  